import { RefObject, CSSProperties, MouseEventHandler } from 'react';
import { MultiValueProps } from 'react-select';
import { SelectOption } from '../../types';
import { Tag } from '@ardoq/status-ui';
import { selectOptionOperations } from '../../selectOptionsOperations';
import { WithPopover } from '@ardoq/popovers';

export const MultiValue = (
  props: MultiValueProps<SelectOption<unknown>> & {
    showDragHandle?: boolean;
    isDeletable?: boolean;
    onMouseDown?: MouseEventHandler<HTMLDivElement>;
    reactSortableRef?: RefObject<HTMLElement>;
    style?: CSSProperties;
    dragTargetClass?: string;
  }
) => {
  const {
    isDeletable = true,
    data,
    removeProps: { onClick },
    onMouseDown,
    showDragHandle,
    reactSortableRef,
    style,
    dragTargetClass,
  } = props;
  const { label, isDisabled, statusType, popoverContent, tooltipText } = data;

  const leftIcon = selectOptionOperations.getIconProps(data, 'left');
  const rightIcon = selectOptionOperations.getIconProps(data, 'right');
  const popoverProps = popoverContent ? { content: popoverContent } : undefined;

  const tag = (
    <Tag
      label={label}
      statusType={statusType}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      onCloseClick={
        isDeletable && !isDisabled ? (onClick as () => void) : undefined
      }
      onMouseDown={onMouseDown}
      showDragHandle={showDragHandle}
      reactSortableRef={reactSortableRef}
      style={style}
      dragTargetClass={dragTargetClass}
      data-tooltip-text={tooltipText}
    />
  );

  if (!popoverProps) return tag;

  return <WithPopover {...popoverProps}>{tag}</WithPopover>;
};
